<div class="starter">
  <span class="starter__text">
     {{starter.name | uppercase}}
  </span>
 </div>
